import { render, staticRenderFns } from "./CartLedger.vue?vue&type=template&id=12df147c&"
import script from "./CartLedger.vue?vue&type=script&lang=js&"
export * from "./CartLedger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports